var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button-group",
    { staticClass: "d2-table-columns-fixed-controller" },
    _vm._l(_vm.options, function(option) {
      return _c("d2-button", {
        key: option.icon,
        attrs: {
          type: _vm.value === option.value ? "primary" : "default",
          icon: option.icon
        },
        on: {
          click: function($event) {
            return _vm.submit(option.value)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }